import { useState } from 'react';
import { Link } from 'react-router-dom';

interface FAQItem {
  q: string;
  a: string;
}

const faqs: FAQItem[] = [
  {
    q: '91浏览器支持哪些手机平台？',
    a: '91浏览器目前支持Android 7.0及以上版本和iOS 13.0及以上版本的智能手机，覆盖市面上绝大多数主流机型。您可以在各大应用商店或官方网站下载对应版本。',
  },
  {
    q: '91浏览器是免费的吗？',
    a: '是的，91浏览器完全免费使用。我们承诺不向用户收取任何费用，所有核心功能均免费开放，无隐藏收费项目。',
  },
  {
    q: '如何开启隐私保护模式？',
    a: '打开91浏览器后，点击底部菜单栏的"标签页"图标，然后选择"无痕浏览"即可开启隐私保护模式。在此模式下，浏览器不会记录您的浏览历史、Cookie和表单数据。',
  },
  {
    q: '91浏览器的数据同步安全吗？',
    a: '非常安全。91浏览器采用端到端加密技术传输同步数据，所有书签、密码和历史记录在离开您的设备前已被加密，即使是我们的服务器也无法解密您的数据。',
  },
  {
    q: '如何在多设备间同步书签？',
    a: '在每台设备上登录同一个91账号，进入设置 → 账号与同步，开启"书签同步"选项即可。您的书签将自动在所有设备间保持同步。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-sm font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            快速解答你的疑惑
          </h2>
          <p className="text-foreground-500">
            找不到答案？查看完整
            <Link to="/category/faq" className="text-primary-600 hover:text-primary-700 font-medium mx-1">
              常见问题
            </Link>
            或
            <Link to="/about" className="text-primary-600 hover:text-primary-700 font-medium ml-1">
              联系我们
            </Link>
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="font-medium text-foreground-900 pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 ${
                      openIdx === idx ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed bg-background-50">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}